<template>
  <v-list-item class='pl-2'>
    <div class='my-3' style='width: 150px'>
      <div class='mb-3 d-flex justify-space-around'>
        <router-link :to="mediaRoot" target='_blank'>
          <v-img v-if="siteFavicon != null" :src='siteFavicon' class='l-sidebar__siteFavicon mr-1' style='background-color: #fff' />
          <v-img v-else v-bind:src="require('@/assets/small_thumb_no_image.jpg')" class='l-sidebar__siteFavicon mr-1' />
        </router-link>
        <span
          :class='{ "invisible": !opened }'
          class='d-block text-center ma-auto'
          style='max-width: 100px'
        >
          {{ siteName }}
        </span>
      </div>
      <v-btn
        :href='mediaRoot'
        target='_blank'
        :class='{ "invisible": !opened }'
        block
        outlined
        light
        plain
        text
        width='100%'
        style='background-color: #fff'
      >
        メディアを見る
      </v-btn>
    </div>
  </v-list-item>
</template>

<script>
export default {
  name: 'SidebarHeader',
  props: {
    opened: {
      type: Boolean,
      required: true
    },
    siteName: {
      type: String,
      default: ''
    },
    siteFavicon: {
      type: String,
      default: ''
    },
    mediaRoot: {
      type: String,
      default: '/'
    }
  }
}
</script>

<style scoped>
.l-sidebar__siteFavicon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
}

.invisible {
  opacity: 0;
  transition: none;
}
</style>
